<template>
    <div class="pantalla-single-product position-relative">

        <div v-if="!this.product_selected" class="elige-potencia pt-4">
            <h2 class="mb-4 ms-4">Elige otro producto a comparar:</h2>
            <div v-for="(producto, key) in productos" class="enlace-potencia">
                <div class=" d-flex justify-content-between" @click="selectProduct2(producto.producto_slug)">
                    <div>
                        <small>{{ producto.subtext }}</small>
                        <br>
                        <span class="ms-3">{{ producto.nombre }}</span>
                    </div>
                    <div>
                        <i class="fas fa-chevron-right"></i>
                    </div>
                </div>
            </div>
        </div>


        <div v-else class="container-mob w-100 pb-0">

            <div class="producto mt-2">
                <h3 class="mb-2">Comparar</h3>
            </div>

            <table class="tabla-comparador">
                <tr>
                    <td class=""></td>
                    <td class="">
                        <div class="series text-center">
                            <img :src="'/storage/'+this.producto_1.imagenes[0]" class="img-fluid">
                            <p class="color-red mt-3 mb-0">{{this.producto_1.nombre}}</p>
                        </div>
                    </td>
                    <td>
                        <div class="series text-center">
                            <img :src="'/storage/'+this.producto_2.imagenes[0]" class="img-fluid">
                            <p class="color-red mt-3 mb-0">{{this.producto_2.nombre}}</p>
                        </div>
                    </td>
                </tr>
                <tr class="fila-valor" v-for="fila in this.comparativa">
                    <td class="dato-comparador">
                        <span class="">{{fila.atributo}}</span>
                    </td>
                    <td class="segundo-dato comparador-valores">
                        <span class="color-red ">{{fila.valor1}}</span>
                    </td>
                    <td class="comparador-valores">
                        <span class="">{{fila.valor2}}</span>
                    </td>
                </tr>
                <tr class="">
                    <td class="dato-comparador">
                    </td>
                    <td class="text-center">
                        <button class="btn btn-comparador" @click="addToPresupuesto(1)">
                            Añadir a presupuesto
                        </button>
                    </td>
                    <td class="text-center">
                        <button class="btn btn-comparador" @click="addToPresupuesto(2)">
                            Añadir a presupuesto
                        </button>
                    </td>
                </tr>
            </table>

        </div>


        <div class="barra-lateral"></div>
        <div class="btn-home d-flex">
            <div class="align-self-center text-center w-100">
                <a href="javascript: window.history.back();">
                    <i class="fas fa-arrow-left"></i>
                </a>
            </div>
        </div>

        <menu-component></menu-component>
    </div>
</template>

<script>

export default {
    data() {
        return {
            product_selected: false,
            productos: [],
            producto_1: {},
            producto_2: {},
            comparativa: [],
            slug: null,
            errors: null
        };
    },
    methods: {
        selectProduct2(slug) {
            // var that = this;
            this.$store
            .dispatch("getComparacion", {product_1: this.producto_1.slug, product_2: slug})
            .then(response => {
                this.producto_2 = response.data.product_2;
                this.comparativa = response.data.comparativa;
                this.product_selected = true;

                gtag('event', 'Comparar_Productos', {
                    'producto_comparar_1': this.producto_1.nombre,
                    'producto_comparar_2': this.producto_2.nombre,
                    'producto_comparar_1_2': this.producto_1.nombre+'_vs_'+this.producto_2.nombre
                });
            })
            .catch(error => {
                this.errors = error.response.data;
            });
        },
        addToPresupuesto: function (num_presu) {

            let prod_id =  num_presu === 1 ? this.producto_1.id : this.producto_2.id;
            let prod_name =  num_presu === 1 ? this.producto_1.nombre : this.producto_2.nombre;

            this.$store
            .dispatch("addPresupuesto", {id: prod_id})
            .then(response => {
                gtag('event', 'Añadir_Presupuesto', {
                    'producto_nombre': prod_name,
                });
                this.$router.push({name: "presupuestos"});
            })
            .catch(error => {
                this.errors = error.response.data;
            });
        }
    },
    mounted: function () {
        this.slug = this.$route.params.producto_1;
        this.$store
        .dispatch("getProduct", {slug: this.slug, comparador: true})
        .then(response => {
            this.producto_1 = response.data;
        })
        .catch(error => {
            this.errors = error.response.data;
        });

        this.$store
        .dispatch("getProductsComparador", {slug: this.slug})
        .then(response => {
            this.productos = response.data;
        })
        .catch(error => {
            this.errors = error.response.data;
        });
    }
};
</script>
